import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainRoute from './routes/mainRoute/mainRoute';
import AuthRoute from './routes/authRoute/authRoute';
import Home from './pages/main/home/home';
import Contact from './pages/main/contact/contact';
import Project from './pages/main/project/project';
import ProjectDetail from './pages/main/project/components/singleProduct';
import Blogs from './pages/main/blog/blogs';
import SingleBlog from './pages/main/blog/components/singleBlog';

function App() {
  return (
    <div className="!overflow-hidden">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainRoute />}>
          <Route path="/" element={<Home/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/project" element={<Project/>}/>
          <Route path="/blogs" element={<Blogs/>}/>
          <Route path="/blogs/:id" element={<SingleBlog/>}/>
          <Route path="/projects/:id" element={<ProjectDetail />} />
        </Route>
        <Route path="/auth" element={<AuthRoute/>}>

        </Route>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
